import { onINP } from 'web-vitals/attribution'
import { gnarSpec } from '../../tracking/gnar'

export const trackPerformance = (pageId: string, pageSlug: string, referrer: string, url: string) => {
  onINP((metric) => {
    const { eventTarget, eventTime, eventType, loadState } = metric.attribution
    gnarSpec.pagePerformanceInp(
      pageId,
      pageSlug,
      referrer,
      url,
      metric.value,
      eventTarget,
      eventTime,
      eventType,
      loadState
    )
  })
}
